var map = {
	"./01-sultanahmet-camii.webp": 813,
	"./02-ayasofya.webp": 805,
	"./03-suleymaniye-camii.webp": 400,
	"./04-kiz-kulesi.webp": 544,
	"./05-ortakoy-camii.webp": 202,
	"./06-galata-kulesi.webp": 988
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 598;